import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import c from 'classnames';
import s from './InputFieldOutline.scss';
/** The outline and background for our input fields.  */ const InputFieldOutline = (_param)=>{
    var { outlineStyle , className , children  } = _param, rest = _object_without_properties(_param, [
        "outlineStyle",
        "className",
        "children"
    ]);
    return /*#__PURE__*/ React.createElement("div", _extends({
        className: c(s['root'], outlineStyle === 'success' && s['success'], outlineStyle === 'error' && s['error'], outlineStyle === 'disabled' && s['disabled'], className)
    }, rest), children);
};
InputFieldOutline.displayName = 'InputFieldOutline';
export default InputFieldOutline;
